export const colorPalette = {
    pri: '#6a648a',
    sec: '#0091c6',
    ter: '#00a7cf',
    suc: '#3fae2a',
    inf: '#555387',
    war: '#ffb819',
    magenta: '#ca2e55',
    dkblue: '#0085a5',
    dkgold: '#e5a516',
    dkgreen: '#3fae2a',
    dkred: '#e5512e',
    dan: '#e5512e',
    blue: '#00a7cf',
    gold: '#ffb819',
    green: '#00c4b4',
    orange: '#ff6c0c',
    purple: '#555387',
    red: '#ff5a34',
};

const getUniqueColors = (
    colors: Record<string, string>,
    threshold = 50,
): Record<string, string> => {
    const isSimilar = (color1: string, color2: string) => {
        const hexToRgb = (hex: string) => {
            const bigint = parseInt(hex.replace('#', ''), 16);
            return {
                r: (bigint >> 16) & 255,
                g: (bigint >> 8) & 255,
                b: bigint & 255,
            };
        };

        const rgb1 = hexToRgb(color1);
        const rgb2 = hexToRgb(color2);

        const diff = Math.sqrt(
            Math.pow(rgb1.r - rgb2.r, 2) +
                Math.pow(rgb1.g - rgb2.g, 2) +
                Math.pow(rgb1.b - rgb2.b, 2),
        );

        return diff < threshold;
    };

    const keys = Object.keys(colors);
    const values = Object.values(colors);

    const uniqueKeys: string[] = [];
    const uniqueValues: string[] = [];

    for (let i = 0; i < values.length; i++) {
        if (!uniqueValues.some(color => isSimilar(values[i], color))) {
            uniqueKeys.push(keys[i]);
            uniqueValues.push(values[i]);
        }
    }

    return uniqueKeys.reduce(
        (acc, key, index) => ({
            ...acc,
            [key]: uniqueValues[index],
        }),
        {},
    );
};

export const getColorPalette = ({
    primaryColor,
    secondaryColor,
}: {
    primaryColor: string;
    secondaryColor: string;
}) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { pri: _, sec: __, ...others } = colorPalette;

    const newPalette = {
        pri: primaryColor,
        sec: secondaryColor,
        ...others,
    };

    return getUniqueColors(newPalette);
};

export const defaultPrimaryColor = '#6a648a';
export const defaultSecondaryColor = '#0091c6';
export const lightGray = '#D3D3D3';
export const darkGray = '#c4c4c4';
export const tableTagColor = '#FFB819';
